import i18n from '@agentguru/i18n';
import { messages } from './messages';
i18n.addResourceBundle('en_US', 'translation', messages.en_US.translation);
i18n.addResourceBundle('pt_BR', 'translation', messages.pt_BR.translation);
